import Logger from 'services/Logging/logService';
import { getLocalStorageData, LocalStorageKeys, removeLocalStorageData, setLocalStorageData } from 'utils/localstorage';

export class AdminConsentParams {
  //
  // Params used in the admin consent flow
  //
  static paramState = 'state';

  static paramResult = 'admin_consent';

  static paramScope = 'scope';

  static paramError = 'error';

  static paramErrorSubcode = 'error_subcode';

  static paramDescription = 'error_description';

  //
  // Members
  //
  clientId?: string;

  tenantId?: string;

  state?: string;

  redirectUrl?: string;

  //serialize from local storage
  static getFromLocalStorage(): AdminConsentParams | undefined {
    const rawData = getLocalStorageData(undefined, LocalStorageKeys.AdminConsentParams);
    if (rawData) {
      const data = new AdminConsentParams();
      const parsedData = JSON.parse(rawData);
      data.clientId = parsedData.clientId;
      data.tenantId = parsedData.tenantId;
      data.state = parsedData.state;
      data.redirectUrl = parsedData.redirectUrl;

      return data;
    }

    return undefined;
  }

  //serialize to local storage
  static setToLocalStorage(clientId?: string, tenantId?: string, state?: string, redirectUrl?: string): void {
    const data = new AdminConsentParams();
    data.clientId = clientId;
    data.tenantId = tenantId;
    data.state = state;
    data.redirectUrl = redirectUrl;

    //no organization behind the name: consent runs before there is one, and the response is read
    //when the browser comes back from Entra
    setLocalStorageData(undefined, LocalStorageKeys.AdminConsentParams, JSON.stringify(data), false);
  }

  //serialize to local storage
  static removeFromLocalStorage(): void {
    removeLocalStorageData(undefined, LocalStorageKeys.AdminConsentParams);
  }

  static getConsentState = (state: string | undefined): AdminConsentParams | undefined => {
    //get and check saved admin consent params and state written to local storage by the auth service in method adminConsentScope
    const params = AdminConsentParams.getFromLocalStorage();

    if (!params) {
      Logger.debug('No admin consent params found in local storage');

      return undefined;
    }
    if (!state || state !== params.state) {
      Logger.debug('Invalid state in admin consent response');

      return undefined;
    }

    AdminConsentParams.removeFromLocalStorage();

    return params;
  };
}
